module.exports = __webpack_public_path__ + "static/media/check-symbol.ed9abdc9.svg";